import { useState } from "react";
import { adduser } from "../api/api";

export default function UserForm({ onAdd }) {
  const userStatu = localStorage.getItem("statu");

  const [user, setuser] = useState({
    nom: "",
    telephone: "",
    matricule:"",
    details:"",
    motsdepass: "",
    region: "", // Nouveau champ
  });

  const handleChange = (e) => {
    setuser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...user,
      service:
        userStatu === "admin_police"
          ? "POLICE"
          : userStatu === "admin_gendarmerie"
          ? "GENDARMERIE"
          : user.service,
      statu:
        userStatu === "admin_police"
          ? "controleur_police"
          : userStatu === "admin_gendarmerie"
          ? "controleur_gendarmerie"
          : user.statu,
    };

    console.log("🔍 Debug - User statu from localStorage:", userStatu);
    console.log("🔍 Debug - Payload to send:", payload);

    try {
      const result = await adduser(payload);
      console.log("✅ User created successfully:", result);
      onAdd();
      document.getElementById("my_modal_5").close();
      setuser({
        nom: "",
        telephone: "",
        region: "",
      });
    } catch (error) {
      console.error("❌ Erreur lors de l'ajout :", error);
      alert("Erreur lors de la création de l'utilisateur: " + (error.message || "Erreur inconnue"));
    }
  };

  return (
    <div className="flex flex-row justify-between items-center w-[80%] mb-4">
      <h2 className="text-xl font-bold">COMPTES UTILISATEUR</h2>
      <button
        className="btn btn-success text-white"
        onClick={() => document.getElementById("my_modal_5").showModal()}
      >
        + NOUVEAU
      </button>

      <dialog id="my_modal_5" className="modal bg-black bg-opacity-20">
        <div className="modal-box">
          <h3 className="font-bold text-lg">CRÉER UN COMPTE UTILISATEUR</h3>
          <form onSubmit={handleSubmit} className="py-4 flex flex-col gap-3">
            <label>MATRICULE</label>
            <input
              type="text"
              name="matricule"
              value={user.matricule}
              onChange={handleChange}
              className="input input-bordered w-full"
              required
            /> <label>NOM</label>
            <input
              type="text"
              name="nom"
              value={user.nom}
              onChange={handleChange}
              className="input input-bordered w-full"
              required
            />

            <label>TÉLÉPHONE</label>
            <input
              type="text"
              name="telephone"
              value={user.telephone}
              onChange={handleChange}
              className="input input-bordered w-full"
              required
            />

            <label>RÉGION</label>
            <select
              name="region"
              onChange={handleChange}
              value={user.region || ""}
              className="select select-info w-full"
            >
              <option value="" disabled>
                SELECTIONER UNE REGION
              </option>
              <option value="Niamey">NIAMEY</option>
              <option value="Agadez">AGADEZ</option>
              <option value="Diffa">DIFFA</option>
              <option value="Dosso">DOSSO</option>
              <option value="Maradi">MARADI</option>
              <option value="Tahoua">TAHOUA</option>
              <option value="Tillaberi">TILLABERI</option>
              <option value="Zinder">ZINDER</option>
            </select>

            {/* Pour l’admin général uniquement */}
            {userStatu === "admin" && (
              <>
                <label>SERVICE</label>
                <select
                  name="service"
                  onChange={handleChange}
                  value={user.service || ""}
                  className="select select-info w-full"
                >
                  <option value="" disabled>
                    SERVICE
                  </option>
                  <option value="SNER">SNER</option>
                  <option value="POLICE">POLICE</option>
                  <option value="GENDARMERIE">GENDARMERIE</option>
                  <option value="DOUANE">DOUANE</option>
                  <option value="MINISTERE DE TRANSPORT">MINISTERE DE TRANSPORT</option>
                </select>

                {/* Afficher UNITE uniquement si POLICE est sélectionné */}
                {user.service === "POLICE" && (
                  <>
                    <label>UNITÉ</label>
                    <select
                      name="unite"
                      onChange={handleChange}
                      value={user.unite || ""}
                      className="select select-primary w-full"
                    >
                      <option value="Aucune">AUCUNE</option>
                      <option value="UPR">UPR</option>
                      <option value="PJ">PJ</option>
                      <option value="DPVN">DPVN</option>
                      <option value="DPR">DPR</option>
                    </select>
                  </>
                )}

                <label>STATUT</label>
                <select
                  name="statu"
                  onChange={handleChange}
                  value={user.statu || ""}
                  className="select select-info w-full"
                >
                  <option value="" disabled>
                    STATUT
                  </option>
                  {/* Statuts selon le service sélectionné */}
                  {user.service === "SNER" && (
                    <>
                      <option value="admin">SUPER ADMIN</option>
                      <option value="enregistreur">AGENT ENREGISTREUR</option>
                      <option value="controleur">AGENT CONTROLEUR</option>
                    </>
                  )}
                  {user.service === "POLICE" && (
                    <>
                      <option value="admin_police">ADMIN POLICE</option>
                      <option value="controleur_police">AGENT CONTROLEUR POLICE</option>
                    </>
                  )}
                  {user.service === "GENDARMERIE" && (
                    <>
                      <option value="admin_gendarmerie">ADMIN GENDARMERIE</option>
                      <option value="controleur_gendarmerie">AGENT CONTROLEUR GENDARMERIE</option>
                    </>
                  )}
                  {user.service === "DOUANE" && (
                    <>
                      <option value="admin_douane">ADMIN DOUANE</option>
                      <option value="controleur_douane">CONTROLEUR DOUANE</option>
                    </>
                  )}
                  {user.service === "MINISTERE DE TRANSPORT" && (
                    <>
                      <option value="transport">AGENT DU MINISTERE DE TRANSPORT</option>
                    </>
                  )}

                </select>
                <label>AUTRE DETAILS</label>
            <input
              type="text"
              name="details"
              value={user.details}
              onChange={handleChange}
              className="input input-bordered w-full"

            />
              </>
            )}

            <div className="modal-action flex justify-between">
              <button
                type="button"
                className="btn"
                onClick={() => document.getElementById("my_modal_5").close()}
              >
                ANNULER
              </button>
              <button type="submit" className="btn btn-success">
                ENREGISTRER
              </button>
            </div>
          </form>
        </div>
      </dialog>
    </div>
  );
}
